import { createSelector } from '@reduxjs/toolkit'
import { PermissionsServerData } from '@lk/api'

import { RootState } from '../root.reducer'
import { getPermissions as getRootPermissions } from '../root.selectors'
import { PermissionsState } from './permissions.reducer'

export const hasPermission = createSelector(
  [getRootPermissions, (_state, key) => key],
  (permissions, key) => permissions[key],
)

export const getPermissions = createSelector<RootState, PermissionsState, PermissionsServerData>(
  getRootPermissions,
  (permissionsRoot) => permissionsRoot.data,
)
